const {Component} = require("react");
const PropTypes = require("prop-types");
const {pluckKeysExcept} = require("helpers/object");
const $ = require("helpers/element");

class Toggle extends Component {

	static get propTypes() {
		return {
			label: PropTypes.string.isRequired,
			toggled: PropTypes.bool,
			toggledLabel: PropTypes.string,
			targetSelector: PropTypes.string.isRequired,
			targetClassName: PropTypes.string.isRequired
		};
	}

	static get defaultProps() {
		return {
			toggled: false
		};
	}

	constructor(props) {
		super(props);
		this.state = {
			toggled: props.toggled
		};
	}

	get buttonProps() {
		return pluckKeysExcept(this.props, Object.keys(this.constructor.propTypes).concat("onClick", "className"));
	}

	get element() {
		return document.querySelector(this.props.targetSelector);
	}

	get label() {
		return this.state.toggled ? (this.props.toggledLabel || this.props.label) : this.props.label;
	}

	get className() {
		let classList = ["toggle-button"];

		if (this.state.toggled) {
			classList.push("toggled");
		}

		if (typeof this.props.className === "string") {
			classList.push(this.props.className);
		}

		return classList.join(" ");
	}

	onClick = () => {
		const element = this.element;

		if (element) {
			this.setState({toggled: !this.state.toggled}, () => {
				this.state.toggled ?
					$(element).addClass(this.props.targetClassName) :
					$(element).removeClass(this.props.targetClassName);
			});
		}
	};

	render() {
		return (
			<button className={this.className} onClick={this.onClick} {...this.buttonProps}>{this.label}</button>
		);
	}

}

module.exports = Toggle;


// WEBPACK FOOTER //
// ./resources/js/components/mixins/Toggle.js